export default __webpack_public_path__ + "static/media/menu.41772e5e.png";